import React from 'react';

const FullStarIcon2 = React.memo(() => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.7151 7.41495C20.2822 7.49791 20.7533 7.91401 20.9266 8.48482C21.1029 9.05011 20.956 9.67108 20.548 10.0851L16.8865 13.8207L17.7293 19.1626C17.826 19.7503 17.5951 20.3445 17.1338 20.695C16.6725 21.0455 16.061 21.0915 15.5564 20.8138L11.032 18.3229L6.45907 20.8197C5.95455 21.0975 5.34297 21.0515 4.88169 20.701C4.42041 20.3504 4.18952 19.7563 4.28616 19.1686L5.14332 13.891L1.45323 10.0896C1.04402 9.67291 0.896845 9.04914 1.07372 8.48114C1.25059 7.91314 1.72076 7.49967 2.28611 7.41495L7.34194 6.64841L9.65772 1.80858C9.93562 1.30804 10.4472 1 11.0006 1C11.554 1 12.0656 1.30804 12.3435 1.80858L14.605 6.60806L19.7151 7.41495Z"
      fill="#FFC60D"
    />
  </svg>
));

export default FullStarIcon2;
